var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32","viewBox":"0 0 14 14"}},[_c('g',{attrs:{"fill":"none","stroke":"#ea5455","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M13.5 7A6.5 6.5 0 1 1 7 .5"}}),_c('path',{attrs:{"d":"M7 4.5V7L4.46 9.96M10 .5h3.5l-3.5 4h3.5"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }